'use client';

import { useId, useLayoutEffect } from 'react';
import {
  reloadBlockerRegistry,
  type ReloadSafety,
} from '@/lib/reload-blockers';
import type { BackgroundUploadManager } from '@/lib/uploads/upload-manager/background-upload-manager';

/** Handed-off sends keep owning reload safety after their composer is gone. */
export function useBackgroundUploadReloadSafety(
  manager: Pick<BackgroundUploadManager, 'jobs' | 'subscribe'>
) {
  const instance = useId();
  useLayoutEffect(() => {
    // Read raw jobs across every workspace at admission time, before React
    // commits a manager update. Persistence does not waive active-send safety.
    const read = (): ReloadSafety =>
      manager.jobs().length > 0 ? 'blocked' : 'safe';
    const owner = reloadBlockerRegistry.registerReloadBlocker(
      `background-uploads:${instance}`,
      read
    );
    const unsubscribe = manager.subscribe(() => owner.set(read));
    return () => {
      unsubscribe();
      owner();
    };
  }, [manager, instance]);
}
